import { render, staticRenderFns } from "./AuthorityManagement.vue?vue&type=template&id=7476fadc&scoped=true&"
import script from "./AuthorityManagement.vue?vue&type=script&lang=js&"
export * from "./AuthorityManagement.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityManagement.vue?vue&type=style&index=0&id=7476fadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476fadc",
  null
  
)

export default component.exports